import { useSimpleHomePagesQuery } from 'generated/sanity-graphql';

export const useSimpleHomePage = (ids?: string[], skip = false) => {
  const simpleHomePageId = ids ?? [];
  const { data, loading } = useSimpleHomePagesQuery({
    variables: {
      where: {
        _id_in: ids,
      },
    },
    skip: skip || !simpleHomePageId.length,
  });

  const simpleHomePage = data?.allSimpleHomePages;

  return {
    simpleHomePage,
    simpleHomePageLoading: loading,
  };
};
